import React from 'react';
import {Box, Stack, styled, Divider} from '@mui/material';
import {
  Button,
  designSystemToken,
  Icon,
  Tooltip,
  IconName,
} from '@lightricks/react-design-system';

const ACTIONS_BAR_SPACING = 24;

export type ActionItem = {
  id?: string;
  icon?: IconName;
  tooltip?: string;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  isDivider?: boolean;
  isDisabled?: boolean;
};

export type ActionsDisplayProps = {
  actionItems: ActionItem[];
};

const ButtonContainer = styled(Box)`
  &:hover {
    background: ${({className}) =>
      className === 'disabled'
        ? 'unset'
        : designSystemToken('semantic.bg.tertiary')};
    border-radius: 8px;
  }
`;

export function ActionsDisplay(props: ActionsDisplayProps) {
  const {actionItems} = props;
  return (
    <Stack direction="row" spacing={`${ACTIONS_BAR_SPACING}px`}>
      {actionItems.map((actionItem) =>
        actionItem.isDivider ? (
          <Divider key={actionItem.id} orientation="vertical" flexItem />
        ) : (
          <Tooltip
            key={actionItem.id}
            type="dark"
            title={actionItem.tooltip}
            placement="top"
            arrow
          >
            <ButtonContainer>
              <Button
                id={actionItem.id}
                size="medium"
                appearance="neutral"
                mode="plain"
                disabled={actionItem.isDisabled}
                onClick={actionItem.onClick}
                icon={
                  actionItem.icon && (
                    <Icon
                      size="medium"
                      appearance={
                        actionItem.isDisabled ? 'disabled' : 'neutral'
                      }
                      name={actionItem.icon}
                    />
                  )
                }
              />
            </ButtonContainer>
          </Tooltip>
        )
      )}
    </Stack>
  );
}
